// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t3Op","left":"styles_left__3JeXJ"};